export enum ArchiveKeys {
  CUSTOMER = "companies",
  JOBS = "leads",
  CONTACTS = "contacts",
  DOCUMENTS = "documents",
  CUSTOMER_NOTES = "companyNotes",
  JOB_NOTES = "leadNotes",
  QUARRIES = "quarryLocations",
  MATERIAL = "quarryMaterials",
  QUARRY_NOTES = "quarryNotes",
  QUARRY_DOCUMENTS = "quarryDocuments",
  QUARRY_CONTACTS = "quarryContacts",
}

export enum ArchiveId {
  LEAD_ID = "leadId",
  CARRIED_ID = "carrierId",
  TRUCK_ID = "truckId",
  COMPANY_ID = "companyId",
  QUARRY_ID = "quarryId",
}
